import React, {useState} from "react"
import UploadConceptPaperForm from "../components/UploadConceptPaperForm";
import {useSelector} from "react-redux";
import ConceptPaperResultForm from "../components/ConceptPaperResultForm";

interface IProps {

}

const ConceptPaperContainer = (props: IProps)=>{
    const [isUploadForm, setIsUploadForm] = useState(true)
    const [conceptPaper, setConceptPaper] = useState()
    const containerHeight = useSelector((state: any) => state.base.contentDivHeight);
    const handleResult = (conceptPaper :any) => {
        setIsUploadForm(false)
        setConceptPaper(conceptPaper)
    }
    return(
        <div style={{display: "flex", background:"white", flexDirection: "column", height: containerHeight, padding: "10px", overflow: "auto"}}>

            {isUploadForm ? <UploadConceptPaperForm handleResult={handleResult}/>:
            <ConceptPaperResultForm data={conceptPaper} />}
        </div>
    )
}

export default ConceptPaperContainer